// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPayoutDefinitionDto } from './IPayoutDefinitionDto';
import {
    IPayoutDefinitionDtoFromJSON,
    IPayoutDefinitionDtoFromJSONTyped,
    IPayoutDefinitionDtoToJSON,
    IPayoutDefinitionDtoToJSONTyped,
} from './IPayoutDefinitionDto';
import type { ITriggerDto } from './ITriggerDto';
import {
    ITriggerDtoFromJSON,
    ITriggerDtoFromJSONTyped,
    ITriggerDtoToJSON,
    ITriggerDtoToJSONTyped,
} from './ITriggerDto';

/**
 * 
 * @export
 * @interface IProcessingTierDto
 */
export interface IProcessingTierDto {
    /**
     * 
     * @type {number}
     * @memberof IProcessingTierDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IProcessingTierDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IProcessingTierDto
     */
    display_name?: string;
    /**
     * 
     * @type {number}
     * @memberof IProcessingTierDto
     */
    plan_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IProcessingTierDto
     */
    plan_name?: string;
    /**
     * 
     * @type {number}
     * @memberof IProcessingTierDto
     */
    percentage?: number;
    /**
     * 
     * @type {number}
     * @memberof IProcessingTierDto
     */
    payout_definition_id?: number;
    /**
     * 
     * @type {IPayoutDefinitionDto}
     * @memberof IProcessingTierDto
     */
    payout_definition?: IPayoutDefinitionDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof IProcessingTierDto
     * @deprecated
     */
    triggers?: Array<IProcessingTierDtoTriggersEnum>;
    /**
     * 
     * @type {Set<number>}
     * @memberof IProcessingTierDto
     */
    tier_trigger_ids?: Set<number>;
    /**
     * 
     * @type {Array<ITriggerDto>}
     * @memberof IProcessingTierDto
     */
    tier_triggers?: Array<ITriggerDto>;
    /**
     * 
     * @type {number}
     * @memberof IProcessingTierDto
     */
    next_tier_id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IProcessingTierDto
     */
    is_send_trigger_notification?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IProcessingTierDto
     */
    payout_rule_type?: IProcessingTierDtoPayoutRuleTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof IProcessingTierDto
     */
    is_lock_purse?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof IProcessingTierDto
     */
    plan_ids_for_card_purse_lock?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof IProcessingTierDto
     */
    plan_names_for_card_purse_lock?: Array<string>;
}

/**
* @export
* @enum {string}
*/
export enum IProcessingTierDtoTriggersEnum {
    EXTERNAL_DEDUCTIBLE_MET = 'EXTERNAL_DEDUCTIBLE_MET',
    PLAN_DEDUCTIBLE_MET = 'PLAN_DEDUCTIBLE_MET',
    MEMBER_DEDUCTIBLE_MET = 'MEMBER_DEDUCTIBLE_MET',
    EMBEDDED_DEDUCTIBLE_MET = 'EMBEDDED_DEDUCTIBLE_MET'
}
/**
* @export
* @enum {string}
*/
export enum IProcessingTierDtoPayoutRuleTypeEnum {
    NO_EXCEPTIONS = 'NO_EXCEPTIONS',
    WITH_EXCEPTIONS = 'WITH_EXCEPTIONS',
    EXCEPTIONS_ONLY = 'EXCEPTIONS_ONLY'
}


/**
 * Check if a given object implements the IProcessingTierDto interface.
 */
export function instanceOfIProcessingTierDto(value: object): value is IProcessingTierDto {
    return true;
}

export function IProcessingTierDtoFromJSON(json: any): IProcessingTierDto {
    return IProcessingTierDtoFromJSONTyped(json, false);
}

export function IProcessingTierDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IProcessingTierDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'display_name': json['display_name'] == null ? undefined : json['display_name'],
        'plan_id': json['plan_id'] == null ? undefined : json['plan_id'],
        'plan_name': json['plan_name'] == null ? undefined : json['plan_name'],
        'percentage': json['percentage'] == null ? undefined : json['percentage'],
        'payout_definition_id': json['payout_definition_id'] == null ? undefined : json['payout_definition_id'],
        'payout_definition': json['payout_definition'] == null ? undefined : IPayoutDefinitionDtoFromJSON(json['payout_definition']),
        'triggers': json['triggers'] == null ? undefined : json['triggers'],
        'tier_trigger_ids': json['tier_trigger_ids'] == null ? undefined : new Set(json['tier_trigger_ids']),
        'tier_triggers': json['tier_triggers'] == null ? undefined : ((json['tier_triggers'] as Array<any>).map(ITriggerDtoFromJSON)),
        'next_tier_id': json['next_tier_id'] == null ? undefined : json['next_tier_id'],
        'is_send_trigger_notification': json['is_send_trigger_notification'] == null ? undefined : json['is_send_trigger_notification'],
        'payout_rule_type': json['payout_rule_type'] == null ? undefined : json['payout_rule_type'],
        'is_lock_purse': json['is_lock_purse'] == null ? undefined : json['is_lock_purse'],
        'plan_ids_for_card_purse_lock': json['plan_ids_for_card_purse_lock'] == null ? undefined : json['plan_ids_for_card_purse_lock'],
        'plan_names_for_card_purse_lock': json['plan_names_for_card_purse_lock'] == null ? undefined : json['plan_names_for_card_purse_lock'],
    };
}

export function IProcessingTierDtoToJSON(json: any): IProcessingTierDto {
    return IProcessingTierDtoToJSONTyped(json, false);
}

export function IProcessingTierDtoToJSONTyped(value?: IProcessingTierDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'display_name': value['display_name'],
        'plan_id': value['plan_id'],
        'plan_name': value['plan_name'],
        'percentage': value['percentage'],
        'payout_definition_id': value['payout_definition_id'],
        'payout_definition': IPayoutDefinitionDtoToJSON(value['payout_definition']),
        'triggers': value['triggers'],
        'tier_trigger_ids': value['tier_trigger_ids'] == null ? undefined : Array.from(value['tier_trigger_ids'] as Set<any>),
        'tier_triggers': value['tier_triggers'] == null ? undefined : ((value['tier_triggers'] as Array<any>).map(ITriggerDtoToJSON)),
        'next_tier_id': value['next_tier_id'],
        'is_send_trigger_notification': value['is_send_trigger_notification'],
        'payout_rule_type': value['payout_rule_type'],
        'is_lock_purse': value['is_lock_purse'],
        'plan_ids_for_card_purse_lock': value['plan_ids_for_card_purse_lock'],
        'plan_names_for_card_purse_lock': value['plan_names_for_card_purse_lock'],
    };
}

